/* RAMVICO — JS propio (vanilla, sin dependencias) */

function mtInitReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function mtInitCountups() {
  var els = document.querySelectorAll('.mt-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-target') || el.textContent) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(target * eased);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function mtInitResenas() {
  document.querySelectorAll('[data-mt-resenas]').forEach(function (root) {
    var track = root.querySelector('.mt-resenas__track');
    var prev = root.querySelector('[data-mt-prev]');
    var next = root.querySelector('[data-mt-next]');
    if (!track) return;
    function scrollAmount() {
      var card = track.querySelector('.mt-resena');
      return card ? card.getBoundingClientRect().width + 22 : 320;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
}

function mtInitProducto() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var variantsData = [];
    try {
      var script = root.querySelector('[data-mt-variants-json]');
      if (script) variantsData = JSON.parse(script.textContent);
    } catch (e) { variantsData = []; }

    var idInput = root.querySelector('[data-mt-variant-id]');
    var form = root.querySelector('[data-mt-form]');
    var priceEl = root.querySelector('[data-mt-precio-actual]');
    var comparePriceEl = root.querySelector('[data-mt-precio-anterior]');
    var savingsEl = root.querySelector('[data-mt-ahorro]');
    var addBtn = root.querySelector('[data-mt-add]');
    var pillGroups = root.querySelectorAll('[data-mt-option-index]');
    var qtyInput = root.querySelector('[data-mt-qty]');
    var mainImg = root.querySelector('[data-mt-main-image]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var oferta2x = root.querySelector('[data-mt-oferta2x]');
    var oferta2xBtn = root.querySelector('[data-mt-oferta2x-btn]');
    var oferta2xUno = root.querySelector('[data-mt-oferta2x-uno]');
    var oferta2xDos = root.querySelector('[data-mt-oferta2x-dos]');
    var oferta2xFoto = root.querySelector('[data-mt-oferta2x-foto]');
    var oferta2xFotoDisponible = false;
    var oferta2xFotos = {};
    try {
      if (oferta2x) oferta2xFotos = JSON.parse(oferta2x.getAttribute('data-mt-oferta2x-fotos') || '{}');
    } catch (e) { oferta2xFotos = {}; }
    var oferta2xDescuentoSet = oferta2x ? (parseFloat(oferta2x.getAttribute('data-mt-oferta2x-descuento-set')) || 0) : 0;
    var oferta2xDescuentoPiezas = oferta2x ? (parseFloat(oferta2x.getAttribute('data-mt-oferta2x-descuento-piezas')) || 0) : 0;
    var oferta2xDosPrecioEl = oferta2xDos ? oferta2xDos.querySelector('[data-mt-oferta2x-dos-precio]') : null;
    var oferta2xDosTotalEl = oferta2xDos ? oferta2xDos.querySelector('[data-mt-oferta2x-dos-total]') : null;
    var oferta2xDosAhorroEl = oferta2xDos ? oferta2xDos.querySelector('[data-mt-oferta2x-dos-ahorro]') : null;

    function mtStartCountdown(el, textEl, finStr, onExpire) {
      if (!el || !finStr) return;
      var finMs = new Date(finStr).getTime();
      if (isNaN(finMs)) return;
      var intervalo;
      var actualizar = function () {
        var restante = finMs - Date.now();
        if (restante <= 0) {
          clearInterval(intervalo);
          if (onExpire) onExpire();
          return;
        }
        var dias = Math.floor(restante / 86400000);
        var horas = Math.floor((restante % 86400000) / 3600000);
        var minutos = Math.floor((restante % 3600000) / 60000);
        var segundos = Math.floor((restante % 60000) / 1000);
        var texto = '';
        if (dias > 0) texto += dias + 'd ';
        texto += (horas < 10 ? '0' : '') + horas + ':';
        texto += (minutos < 10 ? '0' : '') + minutos + ':';
        texto += (segundos < 10 ? '0' : '') + segundos;
        if (textEl) textEl.textContent = texto;
      };
      actualizar();
      intervalo = setInterval(actualizar, 1000);
    }

    var precioLanzamiento = root.querySelector('[data-mt-precio-lanzamiento]');
    var precioLanzamientoVigente = !!precioLanzamiento;
    mtStartCountdown(
      precioLanzamiento,
      precioLanzamiento ? precioLanzamiento.querySelector('[data-mt-precio-lanzamiento-texto]') : null,
      precioLanzamiento ? precioLanzamiento.getAttribute('data-mt-precio-lanzamiento-fin') : null,
      function () {
        precioLanzamientoVigente = false;
        if (precioLanzamiento) precioLanzamiento.hidden = true;
      }
    );

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function currentSelection() {
      var sel = [];
      pillGroups.forEach(function (group) {
        var active = group.querySelector('.mt-activa');
        sel.push(active ? active.getAttribute('data-mt-value') : null);
      });
      return sel;
    }

    function findVariant() {
      var sel = currentSelection();
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      var esSetCompleto = variant.options[0] === 'Set Completo (Coxis + Lumbar)';
      if (precioLanzamiento) precioLanzamiento.hidden = !precioLanzamientoVigente;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
          if (savingsEl) {
            var pct = Math.round(100 - (variant.price / variant.compare_at_price) * 100);
            savingsEl.textContent = '-' + pct + '%';
            savingsEl.style.display = '';
          }
        } else {
          comparePriceEl.style.display = 'none';
          if (savingsEl) savingsEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.classList.remove('mt-btn--disabled');
          addBtn.textContent = addBtn.getAttribute('data-mt-label-disponible') || 'Añadir al carrito';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('mt-btn--disabled');
          addBtn.textContent = addBtn.getAttribute('data-mt-label-agotado') || 'Agotado';
        }
      }
      if (variant.featured_image && mainImg) {
        setMainImage(variant.featured_image);
      }
      if (variant.featured_media_id && thumbs.length) {
        thumbs.forEach(function (t) {
          var matches = String(t.getAttribute('data-mt-media-id')) === String(variant.featured_media_id);
          t.classList.toggle('mt-activa', matches);
        });
      }
      if (oferta2x) {
        if (oferta2xUno) {
          var unoPrecioEl = oferta2xUno.querySelector('.mt-oferta2x__precio');
          var unoAnteriorEl = oferta2xUno.querySelector('.mt-oferta2x__precio-anterior');
          if (unoPrecioEl) unoPrecioEl.textContent = money(variant.price);
          if (unoAnteriorEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              unoAnteriorEl.textContent = money(variant.compare_at_price);
              unoAnteriorEl.style.display = '';
            } else {
              unoAnteriorEl.style.display = 'none';
            }
          }
        }
        var oferta2xDescuentoPct = esSetCompleto ? oferta2xDescuentoSet : oferta2xDescuentoPiezas;
        if (oferta2xDos && oferta2xDescuentoPct > 0) {
          var descuentoUnidad = Math.floor(variant.price * oferta2xDescuentoPct / 100);
          var precioUnidadDos = variant.price - descuentoUnidad;
          var totalDos = precioUnidadDos * 2;
          var ahorroDos = descuentoUnidad * 2;
          if (oferta2xDosPrecioEl) oferta2xDosPrecioEl.textContent = money(precioUnidadDos);
          if (oferta2xDosTotalEl) oferta2xDosTotalEl.textContent = 'Total: ' + money(totalDos);
          if (oferta2xDosAhorroEl) oferta2xDosAhorroEl.textContent = 'Ahorras ' + money(ahorroDos);
        }
        if (oferta2xDos) oferta2xDos.style.display = oferta2xDescuentoPct > 0 ? '' : 'none';
        if (oferta2x) oferta2x.classList.toggle('mt-oferta2x--solo', !(oferta2xDescuentoPct > 0));
        if (oferta2xFoto) {
          var urlFoto = oferta2xFotos[variant.options[1]];
          if (urlFoto) {
            oferta2xFotoDisponible = true;
            oferta2xFoto.onerror = function () { oferta2xFotoDisponible = false; syncOferta2xSeleccion(); };
            oferta2xFoto.src = urlFoto;
          } else {
            oferta2xFotoDisponible = false;
          }
        }
      }
      syncOferta2xSeleccion();
      pillGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-mt-option-index'), 10);
        var pills = group.querySelectorAll('[data-mt-value]');
        var sel = currentSelection();
        pills.forEach(function (pill) {
          var testSel = sel.slice();
          testSel[idx] = pill.getAttribute('data-mt-value');
          var exists = variantsData.some(function (v) {
            return v.options.every(function (opt, i) { return testSel[i] == null || opt === testSel[i]; });
          });
          pill.disabled = !exists;
        });
      });
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll('[data-mt-value]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          group.querySelectorAll('[data-mt-value]').forEach(function (p) { p.classList.remove('mt-activa'); });
          pill.classList.add('mt-activa');
          updateUI();
        });
      });
    });

    var thumbsList = Array.prototype.slice.call(thumbs);

    // Precarga en segundo plano todas las fotos de la galería para que al
    // cambiar de foto (flechas/miniaturas) sea instantáneo en vez de tener
    // que esperar a que se descargue cada imagen en ese momento.
    thumbsList.forEach(function (t) {
      var full = t.getAttribute('data-mt-full');
      if (full) { var pre = new Image(); pre.src = full; }
    });

    var FADE_MS = 320;
    function setMainImage(url) {
      if (!mainImg || !url) return;
      var currentUrl = mainImg.getAttribute('data-mt-current') || mainImg.src;
      if (url === currentUrl) return;
      var container = mainImg.parentElement;
      var overlay = document.createElement('img');
      overlay.src = url;
      overlay.alt = mainImg.alt;
      overlay.className = 'mt-producto__overlay';
      var cleared = false;
      function finish() {
        if (cleared) return;
        cleared = true;
        mainImg.src = url;
        mainImg.setAttribute('data-mt-current', url);
        if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
      }
      overlay.addEventListener('error', finish);
      overlay.addEventListener('load', function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { overlay.classList.add('mt-visible'); });
        });
        window.setTimeout(finish, FADE_MS + 30);
      });
      container.appendChild(overlay);
    }

    function selectThumb(thumb) {
      if (!thumb) return;
      thumbsList.forEach(function (t) { t.classList.remove('mt-activa'); });
      thumb.classList.add('mt-activa');
      setMainImage(thumb.getAttribute('data-mt-full') || thumb.querySelector('img').src);
    }

    function selectVariantByMediaId(mediaId) {
      if (!mediaId) return false;
      var variant = variantsData.find(function (v) { return v.featured_media_id && String(v.featured_media_id) === String(mediaId); });
      if (!variant) return false;
      pillGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-mt-option-index'), 10);
        var targetValue = variant.options[idx];
        group.querySelectorAll('[data-mt-value]').forEach(function (pill) {
          pill.classList.toggle('mt-activa', pill.getAttribute('data-mt-value') === targetValue);
        });
      });
      updateUI();
      return true;
    }

    thumbsList.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var matched = selectVariantByMediaId(thumb.getAttribute('data-mt-media-id'));
        if (!matched) selectThumb(thumb);
      });
    });

    var navPrev = root.querySelector('[data-mt-nav-prev]');
    var navNext = root.querySelector('[data-mt-nav-next]');
    function moveThumb(delta) {
      if (!thumbsList.length) return;
      var current = thumbsList.findIndex(function (t) { return t.classList.contains('mt-activa'); });
      if (current === -1) current = 0;
      var next = (current + delta + thumbsList.length) % thumbsList.length;
      var nextThumb = thumbsList[next];
      var matched = selectVariantByMediaId(nextThumb.getAttribute('data-mt-media-id'));
      if (!matched) selectThumb(nextThumb);
    }
    if (navPrev) navPrev.addEventListener('click', function () { moveThumb(-1); });
    if (navNext) navNext.addEventListener('click', function () { moveThumb(1); });

    function syncOferta2xSeleccion() {
      if (!oferta2xUno && !oferta2xDos) return;
      var cantidad = parseInt((qtyInput && qtyInput.value) || 1, 10) || 1;
      var esUno = cantidad === 1;
      var esDos = cantidad >= 2;
      if (oferta2xUno) {
        oferta2xUno.classList.toggle('mt-activa', esUno);
        oferta2xUno.setAttribute('aria-pressed', String(esUno));
      }
      if (oferta2xDos) {
        oferta2xDos.classList.toggle('mt-activa', esDos);
        oferta2xDos.setAttribute('aria-pressed', String(esDos));
      }
      if (oferta2xFoto) {
        oferta2xFoto.hidden = !oferta2xFotoDisponible;
      }
    }

    if (qtyInput) {
      root.querySelectorAll('[data-mt-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          syncOferta2xSeleccion();
        });
      });
      root.querySelectorAll('[data-mt-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
          syncOferta2xSeleccion();
        });
      });
      qtyInput.addEventListener('input', syncOferta2xSeleccion);
      qtyInput.addEventListener('change', syncOferta2xSeleccion);
    }

    if (oferta2xUno && qtyInput) {
      oferta2xUno.addEventListener('click', function () {
        qtyInput.value = 1;
        syncOferta2xSeleccion();
      });
    }
    if (oferta2xDos && qtyInput) {
      oferta2xDos.addEventListener('click', function (e) {
        if (e.target === oferta2xBtn) return;
        qtyInput.value = 2;
        syncOferta2xSeleccion();
      });
    }

    if (oferta2xBtn && form) {
      oferta2xBtn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = 2;
        syncOferta2xSeleccion();
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    if (qtyInput) {
      var qtyDesdeUrl = new URLSearchParams(window.location.search).get('quantity');
      var qtyDesdeUrlNum = parseInt(qtyDesdeUrl, 10);
      if (qtyDesdeUrlNum > 0) qtyInput.value = qtyDesdeUrlNum;
    }
    syncOferta2xSeleccion();

    if (form) {
      var cartComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var addBtnEl = addBtn;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtnEl) addBtnEl.setAttribute('aria-disabled', 'true');

        var formData = new FormData(form);
        if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
          formData.append('sections', cartComponent.getSectionsToRender().map(function (s) { return s.id; }));
          formData.append('sections_url', window.location.pathname);
        }

        var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              var currencyCode = (window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
              window.Shopify.analytics.publish('product_added_to_cart', {
                cartLine: {
                  quantity: response.quantity,
                  cost: {
                    totalAmount: {
                      amount: (response.final_line_price || response.price * response.quantity) / 100,
                      currencyCode: currencyCode
                    }
                  },
                  merchandise: {
                    id: 'gid://shopify/ProductVariant/' + response.variant_id,
                    title: response.variant_title || response.title,
                    untranslatedTitle: response.variant_title || response.title,
                    sku: response.sku || null,
                    image: { src: response.image || null },
                    price: { amount: response.price / 100, currencyCode: currencyCode },
                    product: {
                      id: 'gid://shopify/Product/' + response.product_id,
                      title: response.product_title,
                      untranslatedTitle: response.product_title,
                      vendor: response.vendor || '',
                      type: response.product_type || null,
                      url: response.url || null
                    }
                  }
                }
              });
            }
            var cartIcon = document.querySelector('#cart-icon-bubble, cart-icon-bubble');
            if (cartComponent && typeof cartComponent.renderContents === 'function') {
              cartComponent.renderContents(response);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            if (cartIcon) cartIcon.classList.add('mt-bump');
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (addBtnEl) addBtnEl.removeAttribute('aria-disabled');
          });
      });
    }

    updateUI();
  });
}

if (!window.__mtScriptsInit) {
  window.__mtScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    mtInitReveals();
    mtInitCountups();
    mtInitResenas();
    mtInitProducto();
  });
}
